// eslint-disable-next-line import/no-cycle
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    settings: {},
    loading: false,
    loaded: false,
    error: null,
  },
  getters: {
    getSettings: state => state.settings,
    getLoading: state => state.loading,
    getLoaded: state => state.loaded,
    getError: state => state.error,
    getSetting: state => (key, defaultValue = null) => state.settings[key] ?? defaultValue,
    getBookingEnabled: state => state.settings.booking_enabled ?? true,
    canBook: state => (state.settings.booking_enabled ?? true) === true,
  },
  mutations: {
    setSettings: (state, settings) => {
      state.settings = settings
    },
    setSetting: (state, { key, value }) => {
      state.settings[key] = value
    },
    setLoading: (state, loading) => {
      state.loading = loading
    },
    setLoaded: (state, loaded) => {
      state.loaded = loaded
    },
    setError: (state, error) => {
      state.error = error
    },
    resetSettings: state => {
      state.settings = {}
      state.loaded = false
      state.error = null
    },
  },
  actions: {
    fetchSettings(ctx, group = null) {
      // Evita chiamate multiple
      if (ctx.state.loaded || ctx.state.loading) {
        return Promise.resolve(ctx.state.settings)
      }

      ctx.commit('setLoading', true)
      ctx.commit('setError', null)

      const params = group ? { group } : {}

      return new Promise((resolve, reject) => {
        axios
          .get('/api/settings', { params })
          .then(response => {

            const settingsObj = response.data.data.reduce((acc, setting) => {
              acc[setting.key] = setting.value

              return acc
            }, {})

            ctx.commit('setSettings', settingsObj)
            ctx.commit('setLoaded', true)
            resolve(response)
          })
          .catch(error => {
            ctx.commit('setError', 'Impossibile caricare le impostazioni')

            // Default sicuro: booking abilitato
            ctx.commit('setSettings', { booking_enabled: true })
            reject(error)
          })
          .finally(() => {
            ctx.commit('setLoading', false)
          })
      })
    },

    fetchSetting(ctx, { key, defaultValue = null }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/settings/${key}/value`, {
            params: { default: defaultValue },
          })
          .then(response => {
            ctx.commit('setSetting', { key, value: response.data.value })
            resolve(response.data.value)
          })
          .catch(error => {
            ctx.commit('setSetting', { key, value: defaultValue })
            reject(error)
          })
      })
    },
  },
}
